export enum LoginRoute {
  Confirmation = 'confirmation',
  Verification = 'verification',
}
